import { FC } from "react";

import { PlannerInsert } from "../planner/PlannerInsert";

import { CoursePageList } from "./SectionPageList";
import { TopicList } from "./TopicList";

import { useCapabilities } from "store/capability-hooks";

export const CourseContentView: FC = () => {
  const { canAuthorCourse } = useCapabilities();

  return (
    <div className="flex max-w-full flex-col-reverse gap-6 bg-white pb-4 md:flex-row md:items-start">
      <main className="my-4 min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
        {/* Topics */}
        <TopicList />

        {/* Assignments */}
        <CoursePageList canEdit={canAuthorCourse} category="assignment" shouldTruncateList />

        {/* Course Resources */}
        <CoursePageList canEdit={canAuthorCourse} category="course_resource" shouldTruncateList />

        {/* Instructor Workspace */}
        {canAuthorCourse && (
          <CoursePageList
            canEdit={canAuthorCourse}
            category="instructor_workspace"
            shouldTruncateList
          />
        )}
      </main>

      <PlannerInsert />
    </div>
  );
};
